import { inventoryManagementAppStores } from "@intrasync/inventory-management";

/**
 * Inventory Management view stores from `@intrasync/inventory-management`.
 *
 * The package exports `inventoryManagementAppStores` already in the host's
 * `{ name, store }` shape (the hub store plus the 16 feature view stores), so it
 * spreads straight in. Each class is instantiated as `new Store(rootStore)` by
 * RootStore (see src/stores/RootStore.ts). None of the names collide with
 * existing host view stores (verified at wiring time).
 */
const inventoryManagementStoreList = [...inventoryManagementAppStores];

export default inventoryManagementStoreList;
